/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Center, Box, Flex, Text, Table, Tbody, Tr, Th, Td, Tfoot, Thead } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { SectionHeader } from '../../Other';
import CompanyName from '../../CompanyName';
import c from '../../../constant';

function GovernanceActuaryPrint({ title = null, list = [], ...props }) {
	const { t } = useTranslation();

	return (
		<>
			<Flex className="show-only-printing" mt={4} {...props}>
				<Box width="100%">
					<Center>
						<Box
							w="100%"
							bg="white"
							borderRadius={c.borderRadius}
							border="1px solid #dbdbdb"
							boxShadow="0 1px 2px rgba(var(--black, #000), 0.1)"
							pb={2}
						>
							<Flex
								h="48px"
								bg="#FAFAFA"
								pl="16px"
								pr="16px"
								mb="16px"
								alignItems="center"
								justifyContent="space-between"
								borderBottom="1px solid #dbdbdb"
							>
								<SectionHeader title={t(title)} fontSize="lg" />
							</Flex>
							<Box p="16px">
								<Table variant="simple">
									<Thead>
										<Tr>
											<Th>{t('Name of Actuary / Company')}</Th>
											<Th>{t('Designation')}</Th>
											<Th>{t('Qualification')}</Th>
											<Th>{t('Approval Letter')}</Th>
										</Tr>
									</Thead>
									<Tbody>
										{list?.getCompanyActuaries.length <= 0 && (
											<Tr>
												<Td>
													<Text>{t('No Data')}</Text>
												</Td>
											</Tr>
										)}
										{list?.getCompanyActuaries?.map((el, i) => {
											return (
												<Tr cursor="pointer" _hover={{ bg: 'gray.200' }} key={`item-${i}`} bg="white">
													<Td>
														<CompanyName company={el?.actuary} companyName={el?.actuaryName} />
													</Td>
													<Td>{el?.designation}</Td>
													<Td>{el?.qualification}</Td>
													<Td>{el?.approvalLetter}</Td>
												</Tr>
											);
										})}
									</Tbody>
									<Tfoot>
										<Tr>
											<Th>{t('Name of Actuary / Company')}</Th>
											<Th>{t('Designation')}</Th>
											<Th>{t('Qualification')}</Th>
											<Th>{t('Approval Letter')}</Th>
										</Tr>
									</Tfoot>
								</Table>
							</Box>
						</Box>
					</Center>
				</Box>
			</Flex>
		</>
	);
}

export default GovernanceActuaryPrint;
